var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "company-switcher",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closeAndFocusTrigger.apply(null, arguments)
        },
        focusout: _vm.onFocusOut,
      },
    },
    [
      _c("company-switcher-trigger", {
        ref: "trigger",
        attrs: {
          label: _vm.currentLabel,
          "panel-id": _vm.panelId,
          open: _vm.isOpen,
        },
        on: { toggle: _vm.toggle, open: _vm.open },
      }),
      _c("transition", { attrs: { name: "company-switcher-panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "company-switcher__panel",
                attrs: { id: _vm.panelId },
              },
              [
                _c("company-switcher-search-field", {
                  ref: "search",
                  attrs: {
                    "listbox-id": _vm.listboxId,
                    "active-option-id": _vm.activeOptionId,
                  },
                  nativeOn: {
                    keydown: function ($event) {
                      return _vm.onSearchKeydown.apply(null, arguments)
                    },
                  },
                  model: {
                    value: _vm.term,
                    callback: function ($$v) {
                      _vm.term = $$v
                    },
                    expression: "term",
                  },
                }),
                _c("company-switcher-option-list", {
                  attrs: {
                    "listbox-id": _vm.listboxId,
                    options: _vm.filtered,
                    "current-value": _vm.client,
                    "active-index": _vm.activeIndex,
                  },
                  on: {
                    activate: function ($event) {
                      _vm.activeIndex = $event
                    },
                    select: _vm.select,
                  },
                }),
                _vm.canCreate
                  ? _c("company-switcher-create-button", {
                      on: { create: _vm.create },
                    })
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }